import { keys } from '@/app/i18n'
import type { NavItem } from '@/app/nav/collect'
import type { Session } from '@/app/stores/session'

/**
 * The Projects menu (docs/projects/PLAN.md §2), beta only until the feature ships: the `pm` software's own entries
 * (they show only where the API lists the software) and the employee's in `em` (`/em/projects`, `/em/my-work`), shown
 * only where the current workspace has Projects (`ProjectsEnabled`, API.md §8): every employee has `em`, so the flag
 * decides. Phase 2 adds Workload and Reports here.
 */
const projectsEnabled = (session: Session) => Number(session.currentWorkspace?.ProjectsEnabled) === 1

const nav: NavItem[] = [
  {
    id: 'pm-projects',
    title: keys.t('projects.nav.projects'),
    icon: 'folder-kanban',
    to: { name: 'projects' },
    softwares: ['pm'],
    resource: 'projects',
    requiresWorkspace: true,
    beta: true,
    order: 10,
  },
  {
    id: 'pm-my-work',
    title: keys.t('projects.nav.myWork'),
    icon: 'list-checks',
    to: { name: 'pm-my-work' },
    softwares: ['pm'],
    resource: 'projects',
    requiresWorkspace: true,
    beta: true,
    order: 20,
  },
  {
    id: 'pm-time',
    title: keys.t('projects.nav.time'),
    icon: 'clock',
    to: { name: 'pm-time' },
    softwares: ['pm'],
    resource: 'always',
    requiresWorkspace: true,
    beta: true,
    order: 30,
  },
  {
    id: 'pm-project-settings',
    section: 'account',
    title: keys.t('projects.nav.projectSettings'),
    icon: 'settings-2',
    to: { name: 'project-settings' },
    softwares: ['pm'],
    resource: 'projects',
    requiresWorkspace: true,
    beta: true,
    order: 115,
  },
  {
    id: 'em-projects',
    title: keys.t('projects.nav.projects'),
    icon: 'folder-kanban',
    to: { name: 'em-projects' },
    softwares: ['em'],
    userTypes: ['Freelancer'],
    resource: 'always',
    requiresWorkspace: true,
    when: projectsEnabled,
    beta: true,
    // After the employee's own entries (Time off … Suggestions, 10–40), before Tasks (50).
    order: 45,
  },
  {
    id: 'em-my-work',
    title: keys.t('projects.nav.myWork'),
    icon: 'list-checks',
    to: { name: 'em-my-work' },
    softwares: ['em'],
    userTypes: ['Freelancer'],
    resource: 'always',
    requiresWorkspace: true,
    when: projectsEnabled,
    beta: true,
    order: 46,
  },
]

export default nav
